const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

export const getMonthName = (month) => {
  return monthNames[month - 1] || "-";
};
